function buyCake() {
    return {
        type: "BUY_CAKE"
    };
}

function buyIceCream() {
    return {
        type: "BUY_ICECREAM"
    };
}

export const bakeryActions = {
    buyCake: buyCake,
    buyIceCream: buyIceCream
}